// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.subsection {
  margin: 0 auto;
  max-width: 100vw;
  /* background-image: url("./../../ASSETS/BACKGROUND/NoiseBgTall.webp"); */
  background-size: cover;
  padding: 1rem;
  letter-spacing: -0.02em;
  background-color: #425151;
  line-height: 1.1;
}
`, "",{"version":3,"sources":["webpack://./src/PAGES/HOME/index.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gBAAgB;EAChB,yEAAyE;EACzE,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB;AAClB","sourcesContent":[".subsection {\n  margin: 0 auto;\n  max-width: 100vw;\n  /* background-image: url(\"./../../ASSETS/BACKGROUND/NoiseBgTall.webp\"); */\n  background-size: cover;\n  padding: 1rem;\n  letter-spacing: -0.02em;\n  background-color: #425151;\n  line-height: 1.1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
